"use strict";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Grid } from "capitalrx-components-2.0/lib/layout";
import styles from "./MainFormSection.module.css";
export const MainFormSection = (props) => {
  const {
    children,
    sectionTitle,
    theme = "",
    showRequire = false,
    removeSectionTitle = false,
    removeSectionTitleWrapper = false,
    bordered = false
  } = props;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Grid.Span, { columns: 12, children: /* @__PURE__ */ jsxs("div", { className: classNames(styles.sectionTitleWrapper, { [theme]: !!theme && !removeSectionTitleWrapper }, "wrapper-main"), children: [
      /* @__PURE__ */ jsx("div", { className: classNames(styles.sectionTitle, { [styles.remove]: removeSectionTitle }), children: sectionTitle }),
      showRequire && /* @__PURE__ */ jsxs("div", { className: styles.requiredIndicator, children: [
        /* @__PURE__ */ jsx("span", { children: "*" }),
        "=Required Field"
      ] })
    ] }) }),
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("div", { className: classNames(styles.mainFormSectionContent, { [styles.border]: bordered, [theme]: !!theme && !removeSectionTitleWrapper }, "main-form-section"), children: /* @__PURE__ */ jsx("div", { children }) }) }) })
  ] });
};
